module.exports = __webpack_public_path__ + "static/media/logo.1411b9e4.png";